import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LabTestsListComponent } from './components/lab-tests-list/lab-tests-list.component';
import { LoginComponent } from './components/login/login.component';
import { MsalGuard } from '@azure/msal-angular';
import { CreateProjectComponent } from './components/create-project/create-project.component';
import { ProjectsListComponent } from './components/projects-list/projects-list.component';
import { AccessErrorComponent } from './common/access-error/access-error.component';
import { FinalSampleInputsComponent } from './components/final-sample-inputs/final-sample-inputs.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'createSample', loadChildren: () => import('./components/create-sample/create-sample.module').then(m => m.CreateSampleModule), canActivate: [MsalGuard] },
  { path: 'edit-sample', loadChildren: () => import('./components/create-sample/create-sample.module').then(m => m.CreateSampleModule), canActivate: [MsalGuard] },
  { path: 'finalSampleInputs/:projectId/:projectNumber/:labTestId', component: FinalSampleInputsComponent, canActivate: [MsalGuard] },
  { path: 'lablist', component: LabTestsListComponent, canActivate: [MsalGuard] },
  { path: 'lablist/:projectId/:projectNumber', component: LabTestsListComponent, canActivate: [MsalGuard] },
  { path: 'project', component: CreateProjectComponent, canActivate: [MsalGuard] },
  { path: 'project/:id', component: CreateProjectComponent, canActivate: [MsalGuard] },
  { path: 'projectlist', component: ProjectsListComponent, canActivate: [MsalGuard] },
  { path: 'cce', loadChildren: () => import('./cce/cce.module').then(m => m.CceModule), canActivate: [MsalGuard] },
  { path: 'cce-dewpoint', loadChildren: () => import('./cce-dewpoint/cce-dewpoint.module').then(m => m.CceDewpointModule), canActivate: [MsalGuard] },
  { path: 'bca', loadChildren: () => import('./bca/bca.module').then(m => m.BcaModule), canActivate: [MsalGuard] },
  { path: 'msst', loadChildren: () => import('./msst/msst.module').then(m => m.MsstModule), canActivate: [MsalGuard] },
  { path: 'n-paraffin', loadChildren: () => import('./paraffin/paraffin.module').then(m => m.ParaffinModule), canActivate: [MsalGuard] },
  { path: 'viscosity', loadChildren: () => import('./viscosity/viscosity.module').then(m => m.ViscosityModule), canActivate: [MsalGuard] },
  { path: 'swelling', loadChildren: () => import('./swell/swelling.module').then(m => m.SwellModule), canActivate: [MsalGuard] },
  { path: 'recombination', loadChildren: () => import('./recombination-qc/recombination-qc.module').then(m => m.RecombinationQCModule), canActivate: [MsalGuard] },
  { path: 'cvd', loadChildren: () => import('./cvd/cvd.module').then(m => m.CvdModule), canActivate: [MsalGuard] },
  { path: 'decontamination', loadChildren: () => import('./liveoil-decontamination/live-oil-decontamination.module').then(m => m.LiveOilDecontaminationModule), canActivate: [MsalGuard] },
  { path: 'dle', loadChildren: () => import('./dle/dle.module').then(m => m.DleModule), canActivate: [MsalGuard] },
  { path: 'accesserror', component: AccessErrorComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
